<template>
  <div>
    <h1>Debug</h1>
    <p>{{Settings}}</p>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: 'surequote-debug',
  computed: {
    ...mapGetters(["Settings"])
  },
}
</script>